const offset = 22;
const box = document.getElementById('wrapperA');
const slider = document.getElementById('slider');

const setSliderPosition = pageX => {
  const position = Math.min(
    window.innerWidth - offset,
    Math.max(0 + offset, pageX)
  );

  box.style.width = `${position}px`;
  slider.style.left = `${position - offset}px`;
};

export default setSliderPosition;
